import { useState, useEffect, useCallback } from 'react';

import { useNavElements } from '~/shared/utils/NavElements';

export default function useNavOffsetHeight(height = null) {
  const { headerWrapperRef, topBarWrapperRef } = useNavElements();
  const [navOffsetHeight, setNavOffsetHeight] = useState();

  useEffect(() => {
    if (
      headerWrapperRef.current !== null &&
      topBarWrapperRef.current !== null
    ) {
      const { height: headerHeight } =
        headerWrapperRef.current?.getBoundingClientRect();
      const { height: topBarHeight } =
        topBarWrapperRef.current?.getBoundingClientRect();
      const _offsetHeight = headerHeight - topBarHeight;
      setNavOffsetHeight(
        height !== null ? height - _offsetHeight : _offsetHeight
      );
    }
  }, [height, headerWrapperRef, topBarWrapperRef]);

  return navOffsetHeight;
}

export const useScrollVisibility = (targetRef) => {
  const [isVisible, setIsVisible] = useState(false);
  const { headerAttachmentContainerRef } = useNavElements();

  const handleScroll = useCallback(() => {
    const bounding = targetRef?.current?.getBoundingClientRect();
    const headerAttachmentContainerBounding =
      headerAttachmentContainerRef?.current?.getBoundingClientRect();

    if (
      bounding &&
      headerAttachmentContainerBounding &&
      bounding.top + bounding.height > headerAttachmentContainerBounding.height
    ) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, [targetRef, headerAttachmentContainerRef]);

  useEffect(() => {
    const scrollHandler = () => {
      handleScroll();
    };

    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [targetRef, handleScroll]);

  if (!targetRef.current) {
    return false;
  }

  return isVisible;
};
